module.exports = __webpack_public_path__ + "static/media/get-more-details.93cc2931.jpg";